import axios from 'axios';
import { IUnitOfMeasure } from '../../../@types/model/masterData/unitOfMeasure/unitOfMeasure';
import { IUnitOfMeasureUpsert } from '../../../@types/model/masterData/unitOfMeasure/unitOfMeasureUpsert';
import { UpsertTypeEnum } from '../../../@types/enum/upsertType';

export default class UnitOfMeasureHttpService {
    public static getList = async (lastSyncedTimeUnix : number, signal ?: AbortSignal) : Promise<Array<IUnitOfMeasure>> => {
        const result = await axios.get(`${API_URL}/v1/MasterData/UnitOfMeasure/GetList`, {
            params: {
                lastSyncedTimeUnix
            },
            signal
        });

        return result.data;
    }

    public static upsert = async (upsert : IUnitOfMeasureUpsert, type : UpsertTypeEnum) : Promise<IUnitOfMeasure> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/UnitOfMeasure/${type}`, upsert);

        return result.data;
    }

    public static delete = async (id : number) : Promise<void> => {
        return await axios.delete(`${API_URL}/v1/MasterData/UnitOfMeasure/Delete`, {
            params: { id },
        });
    }
}